import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Container,
  TextField,
  Button
} from '@mui/material';
import CustomerLayout from './CustomerLayout';
import { useLocation } from 'react-router-dom';
import WithAuth from './WithAuth';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const AddCustomer = () => {
  const location = useLocation();
  console.log('location state: ' + location.state);
  const { update = false, formData = {} } = location.state || {}; // Retrieve state or use defaults
  const [file, setFile] = useState(null);

  const [customerData, setCustomerData] = useState({
    name: '',
    Role: '',
    stDepartment: '',
    internalOrExternal: '',
    school: '',
    city: '',
    state: '',
    country: '',
    latitude: '',
    longitude: '',
    ContactNumbers: '',
    emailIds: '',
    programsAttended: '',
    links: '',
    ...formData,
  });

  console.log(formData)

  useEffect(() => {
    if (update && formData) {
      setCustomerData({
        ...formData
      });
    }
  }, [update, formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Customer id: ' + formData._id);
    console.log("Submitting customerData:", customerData); // ← Add this line

    const endpoint = update
      ? `${process.env.REACT_APP_API_URL}/api/customers/${formData._id}`
      : `${process.env.REACT_APP_API_URL}/api/customers/add-customer`;

    const method = update ? 'PUT' : 'POST';

    try {
      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(customerData)
      });

      const result = await response.json();
      if (!response.ok) {
        console.log('Error details:', result);
        throw new Error(result.message || 'Failed to save customer');
      }

      alert(update ? 'Customer updated successfully!' : 'Customer added successfully!');
      console.log('Saved customer:', result);
    } catch (error) {
      console.error('Error saving customer:', error);
      alert(`Error saving customer: ${error.message}`);
    }
  };


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };


  const handleUpload = async () => {
    if (!file) return alert("Please select a file");

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/upload`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json(); // 👈 read actual response

      if (!response.ok) {
        console.error("Upload failed:", result); // 🛠 check full response
        throw new Error(result.error || 'Error uploading file');
      }

      alert('File uploaded successfully');
    } catch (error) {
      console.error('Error uploading file:', error);
      alert(`Error uploading file: ${error.message}`);
    }
  };


  const handleDownloadCSV = () => {
    const dataToExport = [{
      ...customerData,
      ContactNumbers: Array.isArray(customerData.ContactNumbers)
        ? customerData.ContactNumbers.join(',')
        : customerData.ContactNumbers,
      emailIds: Array.isArray(customerData.emailIds)
        ? customerData.emailIds.join(',')
        : customerData.emailIds,
      programsAttended: Array.isArray(customerData.programsAttended)
        ? customerData.programsAttended.join(',')
        : customerData.programsAttended,
      links: Array.isArray(customerData.links)
        ? customerData.links.join(',')
        : customerData.links,
    }];

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "csv",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "text/csv;charset=utf-8;",
    });

    saveAs(blob, `customer_${customerData.name || 'template'}.csv`);
  };


  return (
    <CustomerLayout>
      <Box sx={{ p: { xs: 2, sm: 3 }, pt: { xs: 8, sm: 9 } }}>
        <Container maxWidth="lg">
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: 'background.paper',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider'
            }}
          >
            <Typography variant="h4" gutterBottom>
              {update ? 'Update Customer' : 'Add New Customer'}
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
              <Grid container spacing={3}>
                {/* Name */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={customerData.name}
                    onChange={handleInputChange}
                    placeholder="Enter Name"
                    required
                  />
                </Grid>

                {/* Role */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Role"
                    name="Role"
                    value={customerData.Role}
                    onChange={handleInputChange}
                    placeholder="Enter Role"
                    required
                  />
                </Grid>

                {/* ST Department */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ST Department"
                    name="stDepartment"
                    value={customerData.stDepartment}
                    onChange={handleInputChange}
                    placeholder="Enter ST Department"
                    required
                  />
                </Grid>

                {/* Internal or External */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Internal or External"
                    name="internalOrExternal"
                    value={customerData.internalOrExternal}
                    onChange={handleInputChange}
                    placeholder="Internal or External"
                    required
                  />
                </Grid>

                {/* School */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="School"
                    name="school"
                    value={customerData.school}
                    onChange={handleInputChange}
                    placeholder="Enter School"
                    required
                  />
                </Grid>

                {/* City */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="City"
                    name="city"
                    value={customerData.city}
                    onChange={handleInputChange}
                    placeholder="Enter City"
                    required
                  />
                </Grid>

                {/* State */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="State"
                    name="state"
                    value={customerData.state}
                    onChange={handleInputChange}
                    placeholder="Enter State"
                    required
                  />
                </Grid>

                {/* Country */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Country"
                    name="country"
                    value={customerData.country}
                    onChange={handleInputChange}
                    placeholder="Enter Country"
                    required
                  />
                </Grid>

                {/* Latitude */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Latitude"
                    name="latitude"
                    value={customerData.latitude}
                    onChange={handleInputChange}
                    placeholder="Enter Latitude"
                  />
                </Grid>

                {/* Longitude */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Longitude"
                    name="longitude"
                    value={customerData.longitude || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Longitude"
                  />
                </Grid>

                {/* Contact Numbers */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Contact Numbers"
                    name="ContactNumbers"
                    value={customerData.ContactNumbers}
                    onChange={handleInputChange}
                    placeholder="Enter Contact Numbers"
                  />
                </Grid>

                {/* Email IDs */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email IDs"
                    name="emailIds"
                    value={customerData.emailIds}
                    onChange={handleInputChange}
                    placeholder="Enter Email IDs"
                  />
                </Grid>

                {/* Programs Attended */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Programs Attended"
                    name="programsAttended"
                    value={customerData.programsAttended}
                    onChange={handleInputChange}
                    placeholder="Enter Programs Attended"
                    required
                  />
                </Grid>

                {/* Links */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Links"
                    name="links"
                    value={customerData.links}
                    onChange={handleInputChange}
                    placeholder="Enter Links"
                    required
                  />
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{ mt: 2 }}
                  >
                    {update ? 'Update Customer' : 'Add Customer'}
                  </Button>
                </Grid>
              </Grid>
              <br />
              {/*             
          <Box sx={{ p: '20px' }}> */}
              <Typography variant="h4" gutterBottom>
                Upload CSV File
              </Typography>
              <TextField
                type="file"
                onChange={handleFileChange}
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpload}
                style={{ marginTop: '20px' }}
              >
                Upload
              </Button>

              <br />

              {/* <Typography variant="h4" gutterBottom>
                Download CSV File
              </Typography> */}
              <Button
                variant="contained"
                color="primary"
                onClick={handleDownloadCSV}
                style={{ marginTop: '20px' }}
              >
                Download
              </Button>


            </Box>
          </Paper>
        </Container>

      </Box>
    </CustomerLayout>
  );
};

export default WithAuth(AddCustomer);
